import classnames from 'classnames';
import { VARIATIONS_PER_ROW, VARIATION_CARD_CLASSNAME } from './constants';

const getFirstUnfilledRowItemIndex = (totalItems, itemsPerRow) => Math.floor(totalItems / itemsPerRow) * itemsPerRow;
const getUnfilledRowItemsMap = (variationsAmount) => ({
    default: getFirstUnfilledRowItemIndex(variationsAmount, VARIATIONS_PER_ROW.default),
    sm: getFirstUnfilledRowItemIndex(variationsAmount, VARIATIONS_PER_ROW.sm),
    md: getFirstUnfilledRowItemIndex(variationsAmount, VARIATIONS_PER_ROW.md),
});

export const getRowItemClassNameByIndex = (variationsAmount, index) => {
    const unfilledRowItemsMap = getUnfilledRowItemsMap(variationsAmount);

    return classnames(VARIATION_CARD_CLASSNAME, {
        'hide-variation': index >= unfilledRowItemsMap.default,
        'hide-variation-sm': index >= unfilledRowItemsMap.sm,
        'hide-variation-md': index >= unfilledRowItemsMap.md,
    });
};
